import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { EmployeeProviderMetadataSchema } from './employee-provider-metadata.schema';
import { DtoType } from '@core/data/dto/dto-types';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';

@DtoForceConstructor
export class EmployeeProviderMetadata {

    public ossId: string;

    @DtoImport(EmployeeProviderMetadataSchema)
    static import(dto: Dto): any {
        return new EmployeeProviderMetadata(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeProviderMetadataSchema,
        },
    ])
    export(type?: DtoType): any {}
}
